"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieServiceV1Impl = void 0;
const Cookies = require("js-cookie");
__exportStar(require("./types"), exports);
class CookieServiceV1Impl {
    constructor(consentManager, serverCookies, serializedStateManager) {
        this.consentManager = consentManager;
        this.serverCookies = serverCookies;
        this.knownCookies = new Map();
        if (serializedStateManager) {
            const state = serializedStateManager.getSerializedState();
            if (state) {
                const cookieList = JSON.parse(state);
                const cookieDefinitions = cookieList.reduce((registrations, cookieEntry) => registrations.concat(cookieEntry.classifications.map((classification) => ({
                    classification,
                    name: cookieEntry.name,
                }))), []);
                this.registerCookies(cookieDefinitions);
            }
            serializedStateManager.register(() => JSON.stringify(this.cookieList));
        }
        if (!serverCookies) {
            this.consentManager.subscribe((newConsent) => {
                this.removeUnconsentedCookies(newConsent);
            });
        }
    }
    get currentConsent() {
        return Object.assign({}, this.consentManager.currentConsent);
    }
    get cookieList() {
        return Array.from(this.knownCookies.entries()).map(([cookieName, classifications]) => ({
            name: cookieName,
            classifications: Array.from(classifications.values()),
        }));
    }
    registerCookies(cookies) {
        cookies.forEach(({ name, classification }) => {
            this.addKnownCookie(name, classification);
            // if there is no consent for the cookie => remove it
            if (!this.hasConsent(name)) {
                this.remove(name);
            }
        });
    }
    get(cookieName) {
        if (!this.hasConsent(cookieName)) {
            return undefined;
        }
        return this.serverCookies ? this.serverCookies[cookieName] : Cookies.get(cookieName);
    }
    set(cookieName, value, options) {
        // it is not possible to set cookies on the server
        // or if the user didn't consent
        if (this.serverCookies || !this.hasConsent(cookieName)) {
            return false;
        }
        Cookies.set(cookieName, value, options);
        return true;
    }
    remove(cookieName, options) {
        if (this.serverCookies || !Cookies.get(cookieName)) {
            return false;
        }
        Cookies.remove(cookieName, options);
        return true;
    }
    addKnownCookie(name, classification) {
        const existingCookie = this.knownCookies.get(name);
        if (!existingCookie) {
            this.knownCookies.set(name, new Set([classification]));
        }
        else if (!existingCookie.has(classification)) {
            existingCookie.add(classification);
        }
    }
    hasConsent(cookieName, consent = this.currentConsent) {
        const classifications = this.knownCookies.get(cookieName);
        // All cookies that are handled via this service have to be registered first
        if (!classifications) {
            return false;
        }
        return Array.from(classifications).some((classification) => consent[classification]);
    }
    removeUnconsentedCookies(consentState) {
        Array.from(this.knownCookies.keys()).forEach((cookieName) => {
            // if there is currently no consent for the cookie => remove it
            if (!this.hasConsent(cookieName, consentState)) {
                this.remove(cookieName);
            }
        });
    }
}
exports.CookieServiceV1Impl = CookieServiceV1Impl;
//# sourceMappingURL=index.js.map